import React, { useState } from "react";

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index, e) => {
    e.preventDefault();
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [
    {
      question:
        "How do I start online consultation with pharmacist on Pharmind?",
      answer:
        "To start an online consultation with a pharmacist on Pharmind, simply log in to your account, navigate to the Consultation section, and select Start Online Consultation. You’ll be connected to a qualified pharmacist via chat or video call, depending on availability, to discuss your health concerns or medication needs.",
    },
    {
      question: "Are your online pharmacist qualified?",
      answer:
        "Yes, all our online pharmacists are fully licensed and certified professionals with extensive training in pharmaceutical care. They adhere to strict regulatory standards to ensure you receive safe and accurate advice tailored to your needs.",
    },
    {
      question: "Can purchased medicines be sent via online delivery?",
      answer:
        "Absolutely! Once your order is confirmed and processed, we offer fast and reliable delivery services to your doorstep. Shipping options and timelines will be provided at checkout, ensuring your medicines arrive safely and on time.",
    },

    {
      question: "What to do if the medication given by the pharmacist does not match?",
      answer:
        "If the medication you receive doesn’t match your prescription or expectations, please contact our customer support team immediately. Do not use the medication. We’ll investigate the issue, provide a replacement if necessary, and ensure your prescription is corrected promptly.",
    },
    {
      question: "Can payments be made by debit or credit?",
      answer:
        "Yes, we accept payments via debit and credit cards for your convenience. During checkout, select your preferred payment method, enter your card details securely, and complete your purchase. We also support other payment options like digital wallets, depending on your region.",
    },
  ];

  return (
    <section className="faq-section" data-aos="fade-up">
      <div className="container">
        {/* FAQ Header */}
        <div className="faq-header">
          <h2 className="faq-title">
            We’ve answered all <span className="text-red big-span">Your Question</span>
          </h2>
        </div>

        {/* Accordion */}
        <div className="accordion-container">
          {faqs.map((faq, index) => (
            <details 
              className="faq-item" 
              key={index}
              open={openIndex === index}
            >
              <summary onClick={(e) => toggleFAQ(index, e)}>
                {faq.question}
                <span className="faq-arrow">
                  <svg
                    width="17"
                    height="10"
                    viewBox="0 0 17 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.21042 1.21045L8.47292 8.47295L15.7354 1.21045"
                      stroke="currentColor"
                      strokeWidth="2.42083"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </summary>
              <div className="faq-content">
                <div className="faq-content-inner">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
